export default __webpack_public_path__ + "static/media/LogoDefault.2505ce6b.svg";